module.exports = __webpack_public_path__ + "img/T915.36f05b21.jpg";